/**
 * @Des 注册 企业账户 弹出层
 * @Auth
 * @Date 2025/10/5
 */
/* HTML */
<template>
	<el-dialog :title="dialogForm.title" :visible.sync="dialogForm.dialogFormVisible" :close-on-click-modal="false" custom-class="form-dialog" v-dialogDrag class="dialog_title" @close="handleDialogClose">

		<el-form label-width="120px" ref="dialogRowForm" :rules="rules" :model="dialogRowForm">
			<el-form-item v-if="!dialogForm.editFlag" label="登陆账户：" prop="account">
				<el-input v-model="dialogRowForm.account" auto-complete="off" autocomplete="false" clearable />
			</el-form-item>
			<el-form-item v-if="!dialogForm.editFlag || dialogForm.editFlag == 'resetpwd'" label="密码：" prop="password">
				<el-input v-model="dialogRowForm.password" type="password" auto-complete="password" autocomplete="false" clearable />
			</el-form-item>
			<el-form-item v-if="!dialogForm.editFlag || dialogForm.editFlag == 'resetpwd'" label="确认密码：" prop="repassword">
				<el-input v-model="dialogRowForm.repassword" type="password" auto-complete="repassword" autocomplete="false" clearable />
			</el-form-item>
			<el-form-item label="备注：" prop="remarks">
				<el-input v-model="dialogRowForm.remarks" clearable />
			</el-form-item>
			<el-form-item class="btn-form-item-c">
				<el-button type="primary" size="primary" :disabled="!dialogForm.editFlag && this.dialogRowForm.roleShow == 'none'" @click="submitForm()">{{dialogForm.submitButton}}</el-button>
			</el-form-item>
		</el-form>
	</el-dialog>

</template>

<script>
	// API 账户
	import ApiAccount from '@/request/api-account';
	// API 登录
	import ApiLogin from '@/request/api-login';
	// 组件 下拉树结构
	import TreeSelect from '@/components/TreeSingleSelect';
	// 组件 校验
	import { validFormat, checkFormat } from '@/global/global-valid';

	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 2025/10/5
		 */
		name: 'RegisterAccountDialog',
		/**
		 * @Des 数据接收类型
		 * @Auth
		 * @Date 2025/10/5
		 */
		props: {
			// 角色集合
			roles: Array,
		},
		/**
		 * @Des 组件引用
		 * @Auth
		 * @Date 2025/10/5
		 */
		components: {
			// 选择树
			TreeSelect,
		},
		/**
		 * @Des 数据定义
		 * @Auth
		 * @Date 2025/10/5
		 */
		data() {
			return {
				/**
				 * @Des 弹出层属性
				 * @Auth
				 * @Date 2025/10/5
				 */
				dialogForm: {
					editFlag: false,
					title: "",
					dialogFormVisible: false,
					submitButton: ''
				},
				/**
				 * @Des 修改表单
				 * @Auth
				 * @Date 2025/10/5
				 */
				dialogRowForm: {
					// 当前账户
					accountId: '',
					// row 下标
					rowIndex: -1,

					// 登录账户
					account: '',
					// 密码
					password: '',
					// 密码
					repassword: '',
					// 备注
					remarks: '',
				},

				/**
				 * @Des 弹窗规则
				 * @Auth
				 * @Date 2025/10/5
				 */
				rules: {
					account: [{
							required: true,
							message: '请输入账户',
							trigger: 'blur'
						},
						{
							validator: (rule, value, callback) => {
								if(!checkFormat(value, validFormat.num_letter_underline)) {
									new callback(new Error("登录账户可包含：字母、数字、下划线"));
								} else {
									callback()
								}
							},
							trigger: "blur"
						}
					],
					password: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							validator: (rule, value, callback) => {
								if(!checkFormat(value, validFormat.password) && false) {
									new callback(new Error("6-18位，可包含数字、字母、英文符号"));
								} else {
									callback()
								}
							},
							trigger: "blur"
						}
					],
					repassword: [{
							required: true,
							message: '请再次输入密码',
							trigger: 'blur'
						},
						{
							validator: (rule, value, callback) => {
								if(!checkFormat(value, validFormat.password) && false) {
									new callback(new Error("6-18位，可包含数字、字母、英文符号"));
								} else if(this.dialogRowForm.repassword != this.dialogRowForm.password) {
									new callback(new Error("两次密码输入不一致"));
								} else {
									callback()
								}
							},
							trigger: "blur"
						}
					],
				}, // rules
				
				// 公钥
				publicKey: null,
				
			}// return
		},// data
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 2025/10/5
		 */
		methods: {
			/**
			 * @Des 打开账户弹窗
			 * @Auth
			 * @Date 2025/10/5
			 */
			openDialog(editFlag, data, rowIndex) {
				// console.log(data);
				this.dialogForm.dialogFormVisible = true;

				this.dialogForm.editFlag = editFlag;
				this.dialogForm.title = (!editFlag ? '注册企业账户' : '编辑企业账户');
				this.dialogForm.submitButton = "提交";
				
				// 获取公钥
				this.getPublicKey();

				// 注册企业账户
				if(!editFlag) {
					this.dialogRowForm.accountId = this.$store.state.account;
				}

				if(!this.$checkEmpty(data)) {

					// 当前账户
					//this.dialogRowForm.accountId = data.accountId;
					// row 下标
					//this.dialogRowForm.rowIndex = rowIndex;

					// 表单
					this.dialogRowForm = Object.assign({}, this.dialogRowForm, data, {
						rowIndex: rowIndex
					});

					let roleIds = {}
					data.roles.forEach((row, index) => {
						roleIds = {
							id: row.roleId,
							label: row.roleName
						}
					});

					// 角色id
					this.dialogRowForm.roleId = roleIds.id;
				}

			},

			/**
			 * @Des 提交账户信息
			 * @Auth
			 * @Date 2025/10/5
			 */
			submitForm() {
				// console.log(this.dialogRowForm)
				/**
				 * @Des 表单校验
				 * @Auth
				 * @Date 2025/10/5
				 */
				this.$refs.dialogRowForm.validate(valid => {
					if(!valid) return false;
					// 交互锁
					if (this.locked) return false;
					
					// 交互锁
					this.locked = true;
					// 交互参数
					let params = {
						// accountId: this.dialogRowForm.accountId,
						account: this.$secret.encryptRSA(this.dialogRowForm.account.trim(), this.publicKey),
						password: this.$secret.encryptRSA(this.dialogRowForm.password.trim(), this.publicKey),
						remarks: this.dialogRowForm.remarks,
						// roleIds: [this.dialogRowForm.roleId],
						// projectId: this.$store.state.currentProjectId
					};

					// 交互 路径
					let submitApi = (!this.dialogForm.editFlag ? ApiLogin.toRegisterAccountApi : ApiAccount.updateAccountApi);

					/**
					 * @Des 数据交互
					 * @Auth
					 * @Date 2025/10/5
					 */
					this.$request.postJsonRequest(submitApi, params).then(result => {
						// 交互锁
						this.locked = false;
						if(result.code == 0) {
							let message = (!this.dialogForm.editFlag ? '企业账户【' + this.dialogRowForm.account + '】新增成功成功！' : '企业账户【' + this.dialogRowForm.account + '】修改成功！');
							this.$message({
								message: message,
								type: 'success',
								showClose: true,
								dangerouslyUseHTMLString: true
							});
							// 关闭弹窗
							this.dialogForm.dialogFormVisible = false;
							if(this.dialogForm.editFlag) {
								// 编辑成功

								// 刷新列表
								this.$emit("search");
							} else {
								// 添加成功
								this.$emit("setTotal", 0);
							}
						} else {
							this.$message({
								message: result.msg,
								type: 'error',
								showClose: true,
								dangerouslyUseHTMLString: true
							});
						}
					}).catch(error => {
						// 交互锁
						this.locked = false;
						console.error(('企业账户'+ (!this.dialogForm.editFlag ? '注册' : '编辑') +'异常'), submitApi, error);
					})
				}); // validata
			},// submitForm
			
			/**
			 * @Des 获取公钥
			 * @Auth
			 * @Date 2025/10/5
			 */
			// 获取公钥
			getPublicKey() {
				// 交互锁
				if (this.locked_publicKey) return false;
				
				// 交互锁
				this.locked_publicKey = true;
				this.$request.postJsonRequest(ApiLogin.getPublicKeyApi, {
					random: Math.random()
				}).then(result => {
					// 交互锁
					this.locked_publicKey = false;
					
					// console.log(result);
					// 返回结果
					if (result.code == 0) {
						// 获取成功
						this.publicKey = result.data;
						
					} else {
						// 获取失败，提示错误信息
						this.$message({
							message: result.msg,
							type: 'error',
							showClose: true,
							dangerouslyUseHTMLString: true
						});
					}
				}).catch(error => {
					// 交互锁
					this.locked_publicKey = false;
					console.error('获取公钥异常', ApiLogin.getPublicKeyApi, error);
				})
			},// getPublicKey

			/**
			 * @Des 关闭弹窗
			 * @Auth
			 * @Date 2025/10/5
			 */
			handleDialogClose() {
				// 重置表单
				this.reset();
			},

			/**
			 * @Des 重置方法
			 * @Auth Zhangbin
			 * @Date 17:28 2021/4/30
			 */
			reset() {
				// 清除表单数据
				this.cleanData(this.dialogRowForm)
				// 清除表单验证
				this.cleanValidate('dialogRowForm');
			},

			/**
			 * @Des 清除验证信息
			 * @Auth
			 * @Date 2025/10/5
			 */
			cleanValidate(formName) {
				// 清除表单校验的提示
				if(this.$refs[formName]) {
					// 延时执行
					this.$nextTick(function() {
						this.$refs[formName].clearValidate();
					})
				};
			},
			/**
			 * @Des 清除数据
			 * @Auth
			 * @Date 2025/10/5
			 */
			cleanData(form) {
				// 重置表单数据
				//this.$refs['dialogRowForm'].resetFields();

				// 延时执行
				this.$nextTick(function() {
					// 当前账户
					form.accountId = '';
					// row 下标
					form.rowIndex = -1;
					// 登录账户
					form.account = '';
					// 密码
					form.password = '';
					// 密码
					form.repassword = '';
					// 备注
					form.remarks = '';
				}); // 延时执行
			},
		}, // methods

	}
</script>
/* JS */ /* CSS */
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components_pages/Account/RegisterAccountDialog.vue